import { DropdownItem } from '@/forms-legacy'
import { useRecurrenceDispatch } from '../../../providers/StateProvider'
import { useCallback } from 'react'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()

  return useCallback(
    (items: DropdownItem[]) => {
      if (items.length > 0) {
        const { id } = items[0]
        dispatch({
          type: 'recurrenceType:change',
          recurrencePeriodType: id as uui.domain.ui.forms.ExtendedRecurrencePeriodType,
        })
      }
    },
    [dispatch],
  )
}
